import { DefaultInput, DefaultFormSelect } from './index'

const booleanSelectOptions = [
    { value: 1, text: 'Enabled' },
    { value: 0, text: 'Disabled' },
]

const typeFields = [
    { value: 'text', text: 'text' },
    { value: 'radio', text: 'radio' },
    { value: 'boolean', text: 'boolean' },
    { value: 'checkbox', text: 'checkbox' },
]

export default {
    name: new DefaultInput('Name'),
    field: new DefaultInput('Field'),
    description: new DefaultInput('Description'),
    length: new DefaultInput('Length'),
    type: new DefaultFormSelect('Type', typeFields, 'type'),
    required: new DefaultFormSelect('Required', booleanSelectOptions, 'required'),
    sort_order: new DefaultInput('Sort order'),
    custom_document_id: new DefaultInput('Custom Document Id'),
    status: new DefaultFormSelect('Status', booleanSelectOptions, 'status'),
    role: new DefaultInput('Role'),
    user_ids: new DefaultInput('User Ids'),
    default_value: new DefaultInput('Default Value'),
}
